import styled from 'styled-components';
import { paddings } from '~/styled/GlobalStyles';

export const UnhandledErrorModal = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Content = styled.div`
  margin: ${paddings.tinyPadding};
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${paddings.largePadding} ${paddings.smallPadding} ${paddings.smallPadding};
`;

export const IconWrapper = styled.div`
  color: var(--functional-error);
  width: 45px;
`;

export const Status = styled.div`
  display: flex;
  margin-right: 10px;
`;

export const Description = styled.div`
  display: flex;
  padding-left: 0;
`;

export const ButtonBar = styled.div`
  text-align: center;
  border-top: 1px solid var(--ui-gray200);
  padding: 1rem;
`;
